module.exports = __webpack_public_path__ + "static/index/img/baikal-308.5330999e.jpg";